import api from './api';

export const aiChatService = {
  async sendMessage(message, history = []) {
    const response = await api.post('/ai-chat/send', {
      message,
      history
    });
    return response.data;
  }
};
